import * as React from 'react';
import styled from 'styled-components';

import ErrorMessage from './ErrorMessage';
import Loading, { LoadingContext } from './Loading';

interface IProps {
  className?: string;
  app: React.StatelessComponent<{}>;
}

interface IState {
  loading: boolean;
}

export class Loader extends React.PureComponent<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  public setVisibility = (loading: boolean) => {
    this.setState({ loading });
  };

  public render() {
    const { className, app } = this.props;
    const App: React.StatelessComponent<{}> = app;

    return (
      <div className={className}>
        <LoadingContext.Provider
          value={{
            setVisibility: this.setVisibility,
            visible: this.state.loading
          }}
        >
          <Loading />
          <ErrorMessage>
            <App {...this.props} />
          </ErrorMessage>
        </LoadingContext.Provider>
      </div>
    );
  }
}

export const AppLoader = styled(Loader)`
  .loading {
    display: flex;
    justify-content: center;
    padding-top: 4rem;
  }
`;

export default AppLoader;
